import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Kind } from "@/lib/api";
import { useAuth } from "@/lib/auth";

type Props = { kind: Kind; className?: string; testid?: string; label?: string };

export function LogoutButton({ kind, className = "", testid, label = "Log out" }: Props) {
  const { signOut } = useAuth();
  const nav = useNavigate();
  return (
    <button
      onClick={() => { signOut(kind); nav("/"); }}
      className={`inline-flex items-center gap-1.5 rounded-sm px-2 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground ${className}`}
      data-testid={testid || `${kind}-logout-button`}
    >
      <LogOut className="h-4 w-4" /> {label}
    </button>
  );
}
